<template>
  <div id="app">
    <Header :links="links"/>
    <Video />
    <TextContainer>
      Электросетевой компьютер (ЭСК AXIOX) - электронно-вычислительное устройство приема и распределения электрической энергии и обеспечения информационного обмена для управления, регулирования и защиты электросети и подключенных к ней устройств.
    </TextContainer>
    <MobileClient />
    <PhoneCarousel />
    <Laptop />
    <Description />
    <Contacts />
    <Glowworm />
  </div>
</template>

<script>
import Header from './containers/Header.vue'
import Video from './containers/Video.vue'
import MobileClient from './containers/MobileClient.vue'
import TextContainer from './containers/TextContainer.vue'
import PhoneCarousel from './containers/PhoneCarousel.vue'
import Laptop from './containers/Laptop.vue'
import Description from './containers/Description.vue'
import Contacts from './containers/Contacts.vue'
import Glowworm from './components/Glowworm.vue'

export default {
  name: 'App',
  components: {
    Header,
    Video,
    MobileClient,
    TextContainer,
    PhoneCarousel,
    Laptop,
    Description,
    Contacts,
    Glowworm
  },
  data: () => ({
    links: [{
      href: "whatisthis",
      label: "Что такое AXIOX"
    },{
      href: "moblie",
      label: "AXIOX Мобильный"
    },{
      href: "howitworks",
      label: "Как это работает"
    },{
      href: "arrangement",
      label: "Из чего это состоит"
    },{
      href: "contacts",
      label: "Контакты"
    }],
    lastScrollTop: 0
  }),
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Montserrat:200,400&display=swap&subset=cyrillic');

@media screen and (min-width: 1200px) {
  #app {
    font-size: 16px;
  }
}

@media screen and (max-width: 500px) {
  #app {
    font-size: 14px;
  }
}

body * {
  outline: none !important;
}

body {
  background-color: #18171a !important;
  padding: 0;
  margin: 0;
}

#app {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  color: white;
}
</style>
